// @ts-nocheck
/* eslint-disable */
export const defaultLocationIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g fill="#31b743" data-name="Group 36348"><path d="M3.529 11.529 0 8l8-8 3.529 3.529-.943.942L8 1.885 1.885 8l2.586 2.586Zm.942.942L8 16l8-8-3.529-3.529-.942.943L14.115 8 8 14.115l-2.586-2.586Z" data-name="Path 6291"/><path d="m12.848 8.001-4.845 4.844-4.845-4.844 4.845-4.844Z" data-name="Path 6292"/></g></svg>`,
    name: 'default-location' as const
};